export const AUTH_LOGIN_PENDING = "AUTH_LOGIN_PENDING";

export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";

export const AUTH_LOGIN_ERROR = "AUTH_LOGIN_ERROR";

export const LOAD_REQUEST = "LOAD_REQUEST";

export const LOAD_REQUEST_COMMIT = "LOAD_REQUEST_COMMIT";

export const LOGIN_REQUEST = "LOGIN_REQUEST";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

export const LOGIN_TOKEN_SAVE = "LOGIN_TOKEN_SAVE";

export const LOGIN_TOKEN_REQUEST = "LOGIN_TOKEN_REQUEST";

export const AUTH_LOGIN_PENDING_CANCEL = "AUTH_LOGIN_PENDING_CANCEL";

export const FORGOT_PASSWORD = "FORGOT_PASSWORD"

export const FORGOT_PASSWORD_PENDING = "FORGOT_PASSWORD_PENDING"

export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS"

export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR"